import { createLifeomicActionTypes } from '../../util/createActionTypes';

export default createLifeomicActionTypes([
  'NOTIFICATIONS_QUEUE_NOTIFICATION',
  'NOTIFICATIONS_DEQUEUE_NOTIFICATION',
]);
